module.exports = __webpack_public_path__ + "static/media/Hassan.bdb2bb14.jpeg";